import React from 'react'

export interface CountryProps {
  name: string
  code: string
  url: string
  annotation?: React.ReactNode
  states: {
    name: string
    code: string
    url: string
    annotation?: React.ReactNode
  }[]
}

export const countries: CountryProps[] = [
  {
    name: 'Australia',
    code: 'AU',
    url: '/listings?type=accommodation&country=AU',
    states: [
      {
        name: 'Victoria',
        code: 'VIC',
        url: '/listings?type=accommodation&country=AU&state=VIC',
      },
      {
        name: 'New South Wales',
        code: 'NSW',
        url: '/listings?type=accommodation&country=AU&state=NSW',
      },
    ],
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    url: '/listings?type=accommodation&country=NZ',
    states: [
      {
        name: 'North Island',
        code: 'NZ',
        url: '/listings?type=accommodation&country=NZ',
      },
    ],
  },
  {
    name: 'United States',
    code: 'US',
    url: '/listings?type=accommodation&country=US',
    states: [
      {
        name: 'Washington State',
        code: 'WA',
        url: '/listings?type=accommodation&country=US&state=WA',
      },
      {
        name: 'Oregon',
        code: 'OR',
        url: '/listings?type=accommodation&country=US&state=OR',
      },
    ],
  },
]
